import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { Section } from 'common';
import strings from 'strings';
import { filterValidItems, isTruthyValue } from 'utils';

import { DescriptionText } from '../../styles';
import { buildMilitaryExperienceString, formatPeriod } from '../../utils';

export const Experience = ({
  experiences = [],
  title = strings.candidates.profile.resumeTab.sections.experience
}) => {
  const validExperiences = filterValidItems(experiences);
  if (validExperiences.length === 0) return null;

  return (
    <Section title={title}>
      <List disablePadding>
        {validExperiences.map(exp => {
          const {
            branch,
            description,
            end_date: endDate,
            location,
            rank,
            start_date: startDate,
            title: itemTitle,
            company
          } = exp;
          const period = [startDate, endDate].filter(Boolean);
          const formattedPeriod = period.map(formatPeriod);
          const militaryExperienceSummary =
            (branch || rank) && buildMilitaryExperienceString({ branch, location, rank });

          return (
            <ListItem
              key={`${company}-${itemTitle || description || Math.random()}`}
              disableGutters
            >
              <ListItemText
                primary={
                  <>
                    {isTruthyValue(company) && (
                      <Typography color="textSecondary">{company}</Typography>
                    )}

                    {isTruthyValue(itemTitle) && (
                      <Typography>
                        <b>{itemTitle}</b>
                      </Typography>
                    )}

                    {isTruthyValue(militaryExperienceSummary) && (
                      <Typography color="textSecondary">{militaryExperienceSummary}</Typography>
                    )}

                    {isTruthyValue(formattedPeriod) && (
                      <Typography color="textSecondary">{formattedPeriod.join(' - ')}</Typography>
                    )}

                    {isTruthyValue(description) && (
                      <DescriptionText component="pre" variant="body1">
                        {description}
                      </DescriptionText>
                    )}
                  </>
                }
              />
            </ListItem>
          );
        })}
      </List>
    </Section>
  );
};
